<template>
  <f7-page name="meteogramy" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Meteogramy</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <template v-if="isStationsLoaded">

      <f7-toolbar top >
        <f7-button v-if="isGeolocationEnabled" @click="selectStationByLocation" class="text-color-black" icon-f7="placemark_fill"></f7-button>
        <f7-list class="ss-list list-meteogram w-100">
          <f7-list-item popup-open=".npw-select-place-popup" link
                        title="Miesto:"
                        :after="selected_station_name">

          </f7-list-item>
        </f7-list>
      </f7-toolbar>


      <f7-popup class="npw-select-place-popup" @popup:opened="onPopupOpen">
        <f7-page class="page-with-subnavbar">
          <f7-navbar>
            <f7-subnavbar :inner="false">
              <f7-searchbar
                      class="nwp-searchbar"
                      search-container=".virtual-list"
                      search-item="li"
                      search-in=".item-title"
                      placeholder="Hľadať..."
                      :disable-button="!$theme.aurora"
                      :remove-diacritics="true"
              >
              </f7-searchbar>



            </f7-subnavbar>

            <f7-nav-title v-if="isGeolocationEnabled">
              <f7-button @click="sortByNearestLocations" class="text-color-black" icon-f7="placemark_fill">Zoradiť podľa vzdialenosti</f7-button>
            </f7-nav-title>
            <f7-nav-title v-else>
              Vyberte miesto:
            </f7-nav-title>

            <f7-nav-right>
              <f7-link popup-close>Návrat</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-list class="searchbar-not-found">
            <f7-list-item title="Miesto nebolo nájdené..."></f7-list-item>
          </f7-list>
          <f7-list
                  class="searchbar-found no-margin-top"
                  virtual-list
                  :virtual-list-params="{ items, searchAll, renderExternal}"

          >
            <ul>
              <f7-list-item
                      v-for="(item, index) in vlData.items"
                      :key="index"
                      @click="selectCity(item.station_id)"
                      :title="item.station_name"
                      :after="item.distance ? item.distance +'km ' : ''"
                      :style="`top: ${vlData.topPosition}px`"
              >
                <f7-badge v-if="selected_station_id === item.station_id" color="blue">✓</f7-badge>
              </f7-list-item>
            </ul>
          </f7-list>

        </f7-page>
      </f7-popup>

      <f7-toolbar tabbar bottom v-if="isDataLoaded" class="meteogramy-tab-links">
        <f7-link tab-link="#meteogramy-tab-1" tab-link-active>ALADIN<br>3 dni</f7-link>
        <f7-link tab-link="#meteogramy-tab-2">ECMWF<br>10 dní</f7-link>
        <f7-link tab-link="#meteogramy-tab-3">ALADIN<br>2 dni</f7-link>
        <f7-link tab-link="#meteogramy-tab-4">ECMWF<br>8 dní</f7-link>
      </f7-toolbar>

      <template v-if="isDataLoaded">
        <f7-tabs swipeable animated class="margin-top-half meteogramy-cards">
          <f7-tab id="meteogramy-tab-1" class="page-content" tab-active>
            <f7-page tabs>
              <pinch-zoom limitPan="true" disableZoomControl="disable" limitZoom="3">
                <img ref="imgMeteogram" :src="meteogramUrl" class="nwp-resp nwp-resp1">
              </pinch-zoom>
            </f7-page>
          </f7-tab>
          <f7-tab id="meteogramy-tab-2" class="page-content">
            <f7-page tabs>
              <pinch-zoom limitPan="true" disableZoomControl="disable" limitZoom="3">
                <img ref="imgEcmgram" :src="ecmgramUrl" class="nwp-resp nwp-resp2">
              </pinch-zoom>>
            </f7-page>
          </f7-tab>
          <f7-tab id="meteogramy-tab-3" class="page-content">
            <f7-page tabs>
              <pinch-zoom limitPan="true" disableZoomControl="disable" limitZoom="3">
                <img ref="imgEpsgram" :src="epsgramUrl" class="nwp-resp nwp-resp3">
              </pinch-zoom>
            </f7-page>
          </f7-tab>
          <f7-tab id="meteogramy-tab-4" class="page-content">
            <f7-page tabs>
              <pinch-zoom limitPan="true" disableZoomControl="disable" limitZoom="3">
                <img ref="imgEpsecmgram" :src="epsecmgramUrl" class="nwp-resp nwp-resp4">
              </pinch-zoom>
            </f7-page>
          </f7-tab>
        </f7-tabs>

      </template>

    </template>
  </f7-page>
</template>
<script>
  import Axios from "axios";
  import SHMUconf from "../js/SHMUconf";

  import PinchZoom from 'vue-pinch-zoom';
  import Utils from "framework7/utils/utils";
  import geoLocationMixin from "../js/geoLocationMixin";

  export default {
    components: {
      'pinch-zoom': PinchZoom
    },
    mixins: [
      geoLocationMixin
    ],
    data: function () {
      return {
        // products: this.$f7.data.products, // ziskanie udajov z globalneho data
        stations: [],
        stationData: [],
        selected_station_id: null,
        isStationsLoaded: false,
        isDataLoaded: false,
        lastUpdated: 0,
        tCheckInterval: null,
        meteogramUrl: null,
        ecmgramUrl: null,
        epsecmgramUrl: null,
        epsgramUrl: null,
        isZoomInitialized: false,
        items:[],
        vlData: {
          items: [],
        },
        currentLocation: null,
      };
    },
    watch: {
      stations() {
        this.items = this.stations;
      },
      stationData: function (val) {
        this.meteogramUrl = this.getMetogramUrl('meteogram', val);
        this.ecmgramUrl = this.getMetogramUrl('ecmgram', val);
        this.epsecmgramUrl = this.getMetogramUrl('epsecmgram', val);
        this.epsgramUrl = this.getMetogramUrl('epsgram', val);
      }
    },
    computed: {
      selected_station_name() {
        const selected_id = this.selected_station_id;
        if (selected_id) {
          let obj = this.stations.find(item => parseInt(item.station_id) === parseInt(selected_id));
          if (obj) {
            return obj.station_name;
          }
        }
        return null;

      }
    },
    mounted() {
      const self = this;
      // otvorime hlavne menu
      this.$f7.accordion.close('.shmu-i-pocasie');
      this.$f7.accordion.open('.shmu-i-pocasie');

    },
    updated() {
      if (this.selected_station_id === null && this.stations.length > 0) {
        //this.$f7.smartSelect.get('.meteogramy-ss-list .smart-select').open();
        this.$f7.popup.get('.npw-select-place-popup').open();
      }
    },
    destroy() {
      clearInterval(this.tCheckInterval);
    },
    methods: {
      onPageInit() {
        this.pageReload(null, true)
      },
      pageReload(event, isInit) {
        const self = this;

        if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh


          let cached_stations = self.$ls.get('nwp_stations');
          if (cached_stations !== null) {
            self.stations = cached_stations;
            self.selected_station_id = this.$ls.get('nwp_station_id');
            self.isStationsLoaded = true;
            self.loadStationData();
          } else {

            self.$f7.dialog.preloader('Načítavam...');

            Axios.get(SHMUconf.API_BASE_URL + 'nwp/getstations', {
              crossDomain: true,
              cache: false,
            })
                    .then((response) => {
                      if (!response.data.error) {
                        self.stations = response.data;
                        self.selected_station_id = this.$ls.get('nwp_station_id');
                        self.isStationsLoaded = true;
                        self.$ls.set('nwp_stations', self.stations, 7 * 24 * 60 * 60 * 1000); // 7 dni
                        self.loadStationData();
                      } else {
                        self.$f7.dialog.alert('Nepodarilo sa načítať zoznam miest pre meteogramy', 'Nastala chyba');
                      }
                      self.$f7.dialog.close();
                    }).catch((error) => {
              self.$f7.dialog.close();
              self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
            });
          }
        }

      },
      onSelectCity(event) {
        this.selected_station_id = parseInt(event.target.value);
        this.$ls.set('nwp_station_id', this.selected_station_id);
        this.loadStationData();
      },
      selectCity(id) {
        // console.log('selected', id);
        this.selected_station_id = parseInt(id);
        this.$f7.popup.get('.npw-select-place-popup').close();
        this.$ls.set('nwp_station_id', this.selected_station_id);
        this.loadStationData();
      },
      loadStationData() {
        const self = this;

        if (this.selected_station_id === null) {
          // ak nie je vybrana stanica, nic nerobime, v updated funkcii sa otvori vyber stanic
        } else {
          self.$f7.dialog.preloader('Načítavam...');
          Axios.get(SHMUconf.API_BASE_URL + 'nwp/getlatestmeteograms?station=' + this.selected_station_id, {
            crossDomain: true,
            cache: false,
          })
                  .then((response) => {
                    if (!response.data.error) {
                      self.stationData = response.data;
                      self.isDataLoaded = true;
                      self.lastUpdated = self.$moment().unix();
                      // clearInterval(this.tCheckInterval);
                      // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu
                    } else {
                      self.$f7.dialog.alert('Nepodarilo sa načítať informácie o meteogramoch', 'Nastala chyba');
                    }
                    self.$f7.dialog.close();
                  }).catch((error) => {
            self.$f7.dialog.close();
            self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
          });
        }

      },
      checkLastUpdated() {
        if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
          this.pageReload(null, false);
        }
      },
      getMetogramUrl(typ, resp_arr) {
        let obj = resp_arr.find(item => (item.typ) === typ);
        return obj.base_url + obj.fname;
      },
      searchAll(query, items) {
        const found = [];
        for (let i = 0; i < items.length; i += 1) {
          if (items[i].station_name.toLowerCase().indexOf(query.toLowerCase()) === 0 || query.trim() === '') found.push(i);
        }
        return found; // return array with mathced indexes
      },
      renderExternal(vl, vlData) {
        this.vlData = vlData;
      },
      onPopupOpen(e) {
        //console.log(this.$f7.searchbar.get('.nwp-searchbar'));
        //this.$f7.initSearchbar('.nwp-searchbar');
      },
      onLocationError(e) {
        this.locationError(this, e);
      },
      onLocationFoundAndSort(e) {
        this.currentLocation = e.coords;

        if (this.currentLocation !== null) {
          for (let i = 0; i < this.stations.length; i++) {
            this.stations[i]["distance"] = this.calculateDistance(
                this.currentLocation.latitude, this.currentLocation.longitude,
                this.stations[i]["gps_lat"], this.stations[i]["gps_lon"],"K").toFixed(2);
          }

          this.stations.sort(function(a, b) {
            return a.distance - b.distance;
          });

          // resetVirtualList
          let listItems = this.$f7.virtualList.get();
          listItems.replaceAllItems(this.stations);

        }


      },
      onLocationFoundAndSelectFirst(e) {
        this.currentLocation = e.coords;

        if (this.currentLocation !== null) {
          for (let i = 0; i < this.stations.length; i++) {
            this.stations[i]["distance"] = this.calculateDistance(
                this.currentLocation.latitude, this.currentLocation.longitude,
                this.stations[i]["gps_lat"], this.stations[i]["gps_lon"],"K").toFixed(2);
          }

          this.stations.sort(function(a, b) {
            return a.distance - b.distance;
          });

          this.selectCity(this.stations[0].station_id);

        }


      },
      sortByNearestLocations() {
        if (this.isGeolocationEnabled) {
          this.getGeoLocation(this.onLocationFoundAndSort, this.onLocationError)
        }
      },
      selectStationByLocation() {
        if (this.isGeolocationEnabled) {
          this.getGeoLocation(this.onLocationFoundAndSelectFirst, this.onLocationError)
        }
      }

    }

  };
</script>

<style lang="scss">


  .meteogramy-tab-links {
    .tab-link {
      font-size: 0.8rem;
      line-height: 0.85rem;
      text-align: center;
    }

    .tab-link-active {
      font-weight: bold;
    }
  }

  .meteogramy-cards {
    margin: 0;
    padding: 0;
    .page-content {
      padding: 0;
      text-align:center;
    }
  }

  .nwp-resp {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }


</style>